import { render, staticRenderFns } from "./BillType.vue?vue&type=template&id=2b53fa3b&scoped=true"
import script from "./BillType.vue?vue&type=script&lang=js"
export * from "./BillType.vue?vue&type=script&lang=js"
import style0 from "./BillType.vue?vue&type=style&index=0&id=2b53fa3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53fa3b",
  null
  
)

export default component.exports